module.exports = __webpack_public_path__ + "static/media/empresa-designs-thumbnail-hd.e097096e.jpg";